import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { LoginService } from './login.service';
import { Perfil } from '../models/perfil';
import { Response } from '../interface/response';
import { NotificacionPerfil } from '../models/notificacionPerfil';

@Injectable({ providedIn: 'root' })
export class NotificacionPerfilService {
    public url: string;

    constructor(private _http: HttpClient, private _loginService: LoginService) {
        this.url = environment.url;
    }

    PorPerfil(iPerfil: Perfil) {
        return this._http.get<Response<NotificacionPerfil>>(this.url + 'Notificaciones/PorPerfil/' + iPerfil.id, { headers: new HttpHeaders().set('Content-Type', 'application/json').set("Authorization", this._loginService.getToken()) });
    }
    Elimina(notificacion: NotificacionPerfil) {
        return this._http.delete<Response<boolean>>(this.url + 'Notificaciones/' + notificacion.id, { headers: new HttpHeaders().set('Content-Type', 'application/json').set("Authorization", this._loginService.getToken()) });
    }
}
